const questions = {
	1: {
		question:
			'Is the underlying asset considered an intangible asset, a biological asset, or inventory?',
		progress: 1,
		info: {
			infoAbbreviated: `
				<b>Common Examples</b><br />
				Intangible Assets: Rights to explore for oil,
				licensing agreements for computer software,
				patents,
				copyrights
				<br /><br />
				Biological Assets: Timber, living plants, living animals
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/prompt/2',
			current: 1,
		},
	},
	2: {
		question: 'Is the agreement a supply contract?',
		progress: 2,
		info: {
			infoAbbreviated: `
				<b>Common Examples</b><br />
				Power purchase agreements,
				take-or-pay agreements
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/prompt/3',
		},
	},
	3: {
		question: 'Is the underlying asset financed with outstanding conduit debt?',
		subQuestion:
			'Are both the underlying asset and the conduit debt reported by the lessor?',
		progress: 3,
		info: {
			infoAbbreviated: `
				<b>Conduit Debt</b><br />
				The GASB defines conduit debt obligations as certain limited-obligation revenue bonds, certificates of participation, or similar debt instruments issued by a state or local governmental entity for the express purpose of providing capital financing for a specific third party that is not a part of the issuer’s financial reporting entity. Although conduit debt obligations bear the name of the governmental issuer, the issuer has no obligation for such debt beyond the resources provided by a lease or loan with the third party on whose behalf they are issued.
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/prompt/4',
		},
	},
	4: {
		question:
			'Does your agreement meet the GASB’s definition of a service concession arrangement?',
		progress: 4,
		info: {
			infoAbbreviated: `
				<b>Service Concession Arrangement Test</b><br />
				GASB 60 defines a service concession arrangement as arrangement between a government (the transferor) and an operator in which all of the following criteria are met: <br />
			`,
			infoExpanded: `
			a. The transferor conveys to the operator the right and related obligation to provide public services through the use and operation of a capital asset or facility in exchange for significant consideration, such as an upfront payment, installment payments, a new facility, or improvements to an existing facility. <br /><br />
			b. The operator collects and is compensated by fees from third parties. <br /><br />
			c. The transferor determines or has the ability to modify or approve what services the operator is required to provide, to whom the operator is required to provide the services, and the prices or rates that can be charged for the services. <br /><br />
			d. The transferor is entitled to significant residual interest in the service utility of the facility at the end of the arrangement. <br /><br />
			<b>Service Concession Arrangements include, but are not limited to:</b><br /><br />
			Arrangements in which the operator will design and build a facility and will obtain the right to collect fees from third parties (for example, construction of a municipal complex for the right to lease a portion of the facility to third parties)<br /><br />
			Arrangements in which the operator will provide significant consideration in exchange for the right to access an existing facility (for example, a parking garage) and collect fees from third parties for its usage<br /><br />
			Arrangements in which the operator will design and build a facility for the transferor (for example, a new tollway), finance the construction costs, provide the associated services, collect the associated fees, and convey the facility to the government at the end of the arrangement
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/prompt/5',
		},
	},
	5: {
		question:
			'Does the contract transfer ownership of the underlying asset to the lessee by the end of the lease term?',
		subQuestion: 'Does the lease agreement contain termination options?',
		progress: 5,
		info: {
			infoAbbreviated: `
				<b>Transfer of Ownership</b><br />
				Under GASB 87, contracts that (1) transfer ownership of the leased asset to the lessee by the end of the contract and (2) do not contain termination options are reported as financed purchases or sales by the lessee/lessor.<br />
			`,
			infoExpanded: `
				Fiscal funding or cancellation clauses that are not reasonably certain to be exercised do not preclude a contract from meeting the definition of a lease under GASB 87. A fiscal funding clause generally provides that the lease is cancelable if the legislature or other funding authority does not appropriate the funds necessary for the governmental unit to fulfill its obligations under the lease agreement.
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/prompt/6',
		},
	},
	6: {
		question:
			'Does the contract transfer control of the underlying asset to the lessee?',
		progress: 6,
		navigation: {
			navYes: '/gasb-87-lease-identifier/prompt/7',
			navNo: '/gasb-87-lease-identifier/submit',
		},
		info: {
			infoAbbreviated: `
				<b>Control Test</b><br />
				Under GASB 87 to have control of the underlying asset the lessee must have both of the following:<br /><br />
				a. The right to obtain the present service capacity from use of the underlying asset as specified in the contract</br ><br />
				b. The right to determine the nature and manner of use of the underlying asset as specified in the contract.
			`,
		},
	},
	7: {
		question: 'Is the underlying asset nonfinancial in nature?',
		progress: 7,
		info: {
			infoAbbreviated: `
				<b>Common Examples</b><br />
				Land, buildings, vehicles, and equipment.
			`,
		},
		navigation: {
			navYes: '/gasb-87-lease-identifier/prompt/8',
			navNo: '/gasb-87-lease-identifier/submit',
		},
	},
	8: {
		question:
			'Does the contract specify a period of time in which the entity can control the underlying asset?',
		progress: 8,
		navigation: {
			navYes: '/gasb-87-lease-identifier/prompt/9',
			navNo: '/gasb-87-lease-identifier/submit',
		},
		info: {
			infoAbbreviated: `
				<b>Period of Time</b><br />
				Under GASB 87, to meet the definition of a lease, a contract must specify a period of time. The period may be for a span of consecutive months or years, but GASB does not require uninterrupted control of the underlying asset for a contract to meet the definition of a lease.<br /><br />
				For example, a government that has a 5-year agreement to use a gymnasium only 3 days a week will have a lease if the other criteria for a lease are met.
			`,
		},
	},
	9: {
		question: 'Do you have an exchange or exchange-like transaction?',
		progress: 9,
		navigation: {
			navYes: '/gasb-87-lease-identifier/submit',
			navNo: '/gasb-87-lease-identifier/submit',
		},
		info: {
			infoAbbreviated: `
				<b>Exchange or Exchange-Like Transaction</b><br />
				Per GASB 33, an exchange is a transaction in which each party receives and gives up essentially equal values. In contrast to a “pure” exchange transaction, an exchange-like transaction is one in which the values exchanged, though related, may not be quite equal or in which the direct benefits may not be exclusively for the parties to the transaction. Nevertheless, the exchange characteristics of the transaction are strong enough to justify treating the transaction as an exchange for accounting recognition. Lease agreements require the lessee and lessor to each receive or give up essentially equal or not quite equal value.
			`,
		},
	},
	submit: {
		question: 'Where would you like to receive results?',
		progress: 10,
	},
}

export default questions
